/* ============================================================
   VD · FICHE PRODUIT · cartes de format vivantes
   ------------------------------------------------------------
   Deux defauts a corriger, tous deux constates en production.

   1. CLIQUER UNE CARTE NE FAISAIT RIEN. Le selecteur du theme
      (vd-yc.js) n ecoute que « .vd-pdp__variant-pill ». Les
      cartes de quantite portent une autre classe, donc aucun
      clic n atteignait la variante.
   2. CHANGER DE CALIBRE NE CHANGEAIT PAS LES PRIX DES CARTES.
      Elles sont rendues par Liquid pour le calibre affiche au
      chargement, et rien ne les recalculait ensuite. Un client
      qui passait de S a XL voyait les prix du S.

   Ce fichier fait les deux : il ecoute les cartes ET les
   pastilles, il synchronise le <select> cache du theme, et il
   REECRIT le contenu des cartes a chaque changement, a partir
   du tableau des variantes depose dans la page.

   Depuis le 03/09/2026 il gere aussi :
   - les ONGLETS de calibre (.vd-cal__tab) : un axe dont les valeurs
     parlent en cm ;
   - les deux PANNEAUX de l axe compte en gousses, « a l unite » et
     « au poids », bascules par un controle segmente qui ne fait que
     changer la vue, sans jamais faire defiler la page ;
   - les cartes au poids : prix, « ≈ N gousses » selon le calibre
     (reglage de section poids_gousse) et prix au kilo ;
   - la pastille « meilleur prix a la gousse » du panneau unite ;
   - le prix principal et le bouton d achat, que personne ne
     mettait a jour quand on cliquait une carte ;
   - l evenement document « vd:variant-change », ecoute par la barre
     d achat fixe et l option de conditionnement.

   Le <select data-vd-variant-select> reste la source de verite et
   recoit toujours son evenement change.

   Aucune librairie. Le prix reste calcule sur les vraies
   donnees Shopify, jamais sur du texte lu a l ecran.
   ============================================================ */
(function () {
  'use strict';

  function argent(cents, format) {
    var val = (cents / 100).toFixed(2);
    if (/\{\{\s*amount\s*\}\}/.test(format)) return format.replace(/\{\{\s*amount\s*\}\}/, val.replace('.', ','));
    if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(format)) return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, val.replace('.', ','));
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(format)) return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    return val.replace('.', ',') + ' €';
  }

  function demarrer(racine) {
    if (racine.getAttribute('data-vd-fmt-init') === '1') { return; }
    racine.setAttribute('data-vd-fmt-init', '1');

    var bloc = racine.querySelector('[data-vd-fmt-data]');
    if (!bloc) { return; }
    var D;
    try { D = JSON.parse(bloc.textContent); } catch (e) { return; }

    var pdp = racine.closest('.vd-pdp') || document;
    var picker = racine;
    var form = pdp.querySelector('[data-vd-pdp-form]');
    var select = form && form.querySelector('[data-vd-variant-select]');

    /* Les valeurs choisies, un element par axe d option. */
    function choix() {
      var out = [];
      var groupes = picker.querySelectorAll('.vd-pdp__variant-group');
      for (var i = 0; i < groupes.length; i++) {
        var c = groupes[i].querySelector('input[type="radio"]:checked');
        out.push(c ? c.value : null);
      }
      return out;
    }

    function variantePour(vals) {
      for (var i = 0; i < D.variants.length; i++) {
        var v = D.variants[i], ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (vals[j] != null && v.options[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) { return v; }
      }
      return null;
    }

    /* Nombre de gousses lu dans une valeur d option. Miroir de
       snippets/vd-compte-gousses.liquid : DETECTION STRUCTURELLE, jamais par
       un mot de langue. Shopify traduit les valeurs d option, « 10 gousses »
       devient « 10 Vanilleschoten », « 10 baccelli di vaniglia »,
       « 10 vanillestokjes » : l ancienne liste de mots francais rendait 0 en
       de, it et nl, et le prix a la gousse n y etait donc jamais ecrit.
       On garde le dernier segment (apres « / » puis « · »), on ecarte les
       longueurs (cm, mm : c est un calibre) et les masses ou volumes
       (g, kg, ml... : c est un conditionnement au poids), et on lit le
       premier nombre de ce qui reste. Le reglage D.mots n est plus utilise.
       Controle du 06/09/2026 : resultat identique a l ancienne regex sur les
       262 variantes du catalogue en francais, et identique au francais dans
       les six langues, la ou l ancienne divergeait 43 fois en de, it et nl. */
    var UNITES_POIDS = ['g', 'kg', 'mg', 'ml', 'cl', 'l', 'oz', 'lb'];
    function gousses(txt) {
      var s = String(txt || '').toLowerCase();
      s = s.split('/').pop();
      s = s.split('·').pop().trim();
      if (s.indexOf('cm') !== -1 || s.indexOf('mm') !== -1) return 0;
      var mots = s.split(/\s+/).filter(Boolean);
      for (var i = 0; i < mots.length; i++) {
        var n = parseInt(mots[i], 10);
        if (!isNaN(n) && n > 0) {
          var suivant = (mots[i + 1] || '').trim();
          return UNITES_POIDS.indexOf(suivant) === -1 ? n : 0;
        }
      }
      return 0;
    }

    /* Grammes par gousse pour le calibre courant. La cle est le premier
       mot de la valeur de calibre (« S · 10 à 12 cm » -> « s »), cherchee
       dans le reglage « S:3,M:4,L:5,XL:6 ». Sans axe de calibre ni cle
       connue : 0, et aucune estimation n est ecrite. */
    function gParGousse(vals) {
      var axe = typeof D.cal_axe === 'number' ? D.cal_axe : -1;
      if (axe < 0 || !vals[axe]) { return 0; }
      var cle = String(vals[axe]).trim().split(/\s+/)[0].toLowerCase();
      var paires = String(D.poids_gousse || '').split(',');
      for (var i = 0; i < paires.length; i++) {
        var kv = paires[i].split(':');
        if (kv.length === 2 && kv[0].trim().toLowerCase() === cle) {
          var g = parseFloat(kv[1].replace(',', '.'));
          if (g > 0) { return g; }
        }
      }
      return 0;
    }

    /* REECRITURE DES CARTES. Pour l axe compte en gousses, on recalcule le
       prix, le prix a la gousse et l ecart, pour le calibre courant ; pour
       les formats au poids, l estimation en gousses et le prix au kilo. */
    function rafraichir() {
      var vals = choix();
      var gpg = gParGousse(vals);

      /* onglets de calibre : etat actif, rupture totale d une valeur */
      racine.querySelectorAll('[data-vd-cal]').forEach(function (liste) {
        var axe = parseInt(liste.getAttribute('data-vd-cal'), 10);
        liste.querySelectorAll('.vd-cal__tab').forEach(function (t) {
          var val = t.getAttribute('data-valeur');
          var actif = vals[axe] === val;
          t.classList.toggle('is-active', actif);
          t.setAttribute('aria-selected', actif ? 'true' : 'false');
          var dispo = D.variants.some(function (v) { return v.available && v.options[axe] === val; });
          t.classList.toggle('is-out', !dispo);
        });
      });

      racine.querySelectorAll('[data-vd-fmt-axe]').forEach(function (grille) {
        var axe = parseInt(grille.getAttribute('data-vd-fmt-axe'), 10);
        var cartes = grille.querySelectorAll('.vd-fmt__opt');

        /* reference d ecart : le prix a la gousse le plus eleve de cet axe,
           a autres options egales ; et le plus bas, pour la pastille */
        var ref = 0, meilleur = 0;
        cartes.forEach(function (c) {
          var val = c.getAttribute('data-valeur');
          var essai = vals.slice(); essai[axe] = val;
          var v = variantePour(essai);
          var n = gousses(val);
          if (v && v.available && n > 0) {
            var u = Math.round(v.price / n);
            if (u > ref) { ref = u; }
            if (!meilleur || u < meilleur) { meilleur = u; }
          }
        });

        var bestPose = false;
        cartes.forEach(function (c) {
          var val = c.getAttribute('data-valeur');
          var essai = vals.slice(); essai[axe] = val;
          var v = variantePour(essai);
          var n = gousses(val);
          var poids = c.getAttribute('data-vd-panneau') === 'poids';
          var g = parseInt(c.getAttribute('data-grammes'), 10) || 0;
          var elPrix = c.querySelector('.vd-fmt__prix');
          var elUnit = c.querySelector('.vd-fmt__unite');
          var elEco = c.querySelector('.vd-fmt__eco');
          var elKg = c.querySelector('.vd-fmt__kg');
          var elBest = c.querySelector('.vd-fmt__best');

          c.classList.toggle('is-active', vals[axe] === val);
          c.classList.toggle('is-out', !(v && v.available));

          if (elPrix) { elPrix.textContent = v ? argent(v.price, D.devise) : ''; }

          if (elUnit) {
            /* le texte va dans le span interne : la pastille de remise et le
               prix au kilo sont les autres enfants du meme conteneur */
            var texte = elUnit.querySelector('span:not(.vd-fmt__eco):not(.vd-fmt__kg)') || elUnit;
            if (poids) {
              var est = (v && gpg > 0 && g > 0) ? Math.round(g / gpg) : 0;
              if (est > 0) { texte.textContent = '≈ ' + est + ' ' + (D.mot_gousses || ''); }
              else if (!(v && v.available)) { texte.textContent = D.mot_rupture; }
              else { texte.textContent = ''; }
              if (elKg) { elKg.textContent = (v && g > 0) ? argent(Math.round(v.price * 1000 / g), D.devise) + (D.par_kg || '/kg') : ''; }
            } else {
              if (v && n > 0) { texte.textContent = argent(Math.round(v.price / n), D.devise) + ' ' + D.mot_gousse; }
              else if (!(v && v.available)) { texte.textContent = D.mot_rupture; }
              else { texte.textContent = ''; }
            }
          }

          if (elEco) {
            var eco = 0;
            if (!poids && v && v.available && n > 0 && ref > 0) {
              var u = Math.round(v.price / n);
              if (u < ref) { eco = Math.round((ref - u) * 100 / ref); }
            }
            elEco.textContent = eco > 0 ? '−' + eco + ' %' : '';
            elEco.hidden = eco <= 0;
          }

          if (elBest) {
            var best = false;
            if (!poids && !bestPose && v && v.available && n > 0 && meilleur > 0 && Math.round(v.price / n) === meilleur) {
              best = true; bestPose = true;
            }
            elBest.hidden = !best;
          }
        });
      });
    }

    /* Le prix principal et le bouton d achat suivent la variante : le
       theme ne le faisait que pour ses pastilles. */
    function refleter(v) {
      var opt = select && select.selectedOptions && select.selectedOptions[0];
      var prix = pdp.querySelector('.vd-pdp__price');
      if (prix && opt && opt.dataset.price) {
        if (opt.dataset.compareAtPrice) {
          prix.innerHTML = '<s class="vd-pdp__price-compare">' + opt.dataset.compareAtPrice + '</s>' +
            '<span class="vd-pdp__price-current vd-pdp__price-sale">' + opt.dataset.price + '</span>';
        } else {
          prix.innerHTML = '<span class="vd-pdp__price-current">' + opt.dataset.price + '</span>';
        }
      }
      var btn = form && form.querySelector('[data-vd-add]');
      if (btn && v) {
        btn.disabled = !v.available;
        var lab = btn.querySelector('.vd-pdp__add-label');
        if (lab && D.btn_add) {
          lab.textContent = v.available ? D.btn_add : (D.bientot ? D.btn_bientot : D.btn_unavailable);
        }
      }
    }

    /* Contrat pour les composants ecrits ailleurs (barre d achat fixe,
       option de conditionnement) : un evenement document par selection. */
    function annoncer(v) {
      var detail = {
        id: v ? v.id : null,
        price: v ? v.price : null,
        options: v ? v.options.slice() : choix(),
        available: v ? !!v.available : false
      };
      try { document.dispatchEvent(new CustomEvent('vd:variant-change', { detail: detail })); } catch (e) { /* rien */ }
    }

    /* Selection : on coche, on synchronise le select cache du theme, et on
       laisse vd-yc.js faire le reste (panier). */
    function selectionner(input) {
      if (!input || input.disabled) { return; }
      var carte_sel = input.closest('.vd-fmt__opt');
      var grille_sel = carte_sel && carte_sel.closest('.vd-fmt__grille[data-vd-panneau]');
      if (grille_sel && carte_sel.getAttribute('data-valeur')) {
        grille_sel.setAttribute('data-vd-dernier', carte_sel.getAttribute('data-valeur'));
      }
      var groupe = input.closest('.vd-pdp__variant-group');
      if (groupe) {
        groupe.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = (r === input); });
        groupe.querySelectorAll('.vd-pdp__variant-pill').forEach(function (p) {
          p.classList.toggle('is-active', p.contains(input));
        });
        groupe.querySelectorAll('.vd-cal__tab').forEach(function (t) {
          var on = t.contains(input);
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var lab = groupe.querySelector('[data-vd-variant-value]');
        if (lab) { lab.textContent = input.value; }
      }
      var v = variantePour(choix());
      if (v && select) {
        select.value = String(v.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      rafraichir();
      refleter(v);
      annoncer(v);
    }

    /* Le controle segmente ne change que la vue. Si la quantite choisie
       n est pas dans le panneau affiche, on prend la premiere carte
       disponible du panneau. Jamais d ancre, jamais de defilement. */
    function basculer(seg) {
      var fmt = seg.closest('[data-vd-fmt-axe]');
      if (!fmt) { return; }
      var cible = seg.getAttribute('data-vd-seg');
      fmt.querySelectorAll('[data-vd-seg]').forEach(function (b) {
        var on = (b === seg);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var visible = null;
      /* ATTENTION : les CARTES portent elles aussi data-vd-panneau (pour que
         rafraichir sache si une carte se compte au poids). Sans le filtre sur
         la grille, la boucle prenait la derniere carte pour le panneau, et la
         bascule « Au poids » selectionnait le kilo au lieu du premier format. */
      fmt.querySelectorAll('.vd-fmt__grille[data-vd-panneau]').forEach(function (p) {
        var on = p.getAttribute('data-vd-panneau') === cible;
        p.hidden = !on;
        if (on) { visible = p; }
      });
      if (visible && !visible.querySelector('input[type="radio"]:checked')) {
        /* On rend au client le format qu il avait deja choisi dans ce panneau :
           sans cette memoire, aller voir les prix au poids puis revenir
           ramenait le choix a « 1 gousse » et le prix avec. */
        var garde = visible.getAttribute('data-vd-dernier');
        var repris = null;
        if (garde) {
          repris = visible.querySelector('.vd-fmt__opt[data-valeur="' + garde.replace(/"/g, '\\"') + '"]:not(.is-out) input[type="radio"]');
        }
        var premier = repris || visible.querySelector('.vd-fmt__opt:not(.is-out) input[type="radio"]') || visible.querySelector('input[type="radio"]');
        if (premier) { selectionner(premier); }
      }
    }

    racine.addEventListener('click', function (e) {
      var seg = e.target.closest('[data-vd-seg]');
      if (seg) { e.preventDefault(); basculer(seg); return; }
      var carte = e.target.closest('.vd-fmt__opt');
      var pastille = e.target.closest('.vd-pdp__variant-pill');
      var onglet = e.target.closest('.vd-cal__tab');
      var cible = carte || pastille || onglet;
      if (!cible) { return; }
      var input = cible.querySelector('input[type="radio"]');
      if (!input) { return; }
      if (input.disabled) { e.preventDefault(); return; }
      e.preventDefault();
      selectionner(input);
    });

    /* clavier : les cartes et les onglets sont des radios, la navigation doit marcher */
    racine.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') { selectionner(e.target); }
    });

    rafraichir();
  }

  function init() {
    var n = document.querySelectorAll('[data-vd-variant-picker]');
    for (var i = 0; i < n.length; i++) { demarrer(n[i]); }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
